class TestimonialSlider extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector('.testimonial__swiper');
    this.prevBtn = this.querySelector('.testimonial__arrow--prev');
    this.nextBtn = this.querySelector('.testimonial__arrow--next');
    this.swiper = null;
    this.syncNavState = this.syncNavState.bind(this);
  }

  connectedCallback() {
    if (!this.swiperEl) return;
    this.initSwiper();
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 1.3,
      spaceBetween: 12,
      slidesOffsetBefore: 12,
      slidesOffsetAfter: 12,
      watchOverflow: true,
      breakpoints: {
        600: { slidesPerView: 1.6, slidesOffsetBefore: 20, slidesOffsetAfter: 24 },
        768: { slidesPerView: 2.4, spaceBetween:20, slidesOffsetBefore: 20, slidesOffsetAfter: 24 },
        1024: { slidesPerView: 4, slidesOffsetBefore: 0, slidesOffsetAfter: 0 },
      },
      pagination: {
        el: this.querySelector('.testimonial__pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },
      on: {
        init: this.syncNavState,
        slideChange: this.syncNavState,
        resize: this.syncNavState,
      },
    });
  }

  syncNavState() {
    if (!this.swiper) return;
    if (this.prevBtn) {
      this.prevBtn.disabled = this.swiper.isBeginning;
      this.prevBtn.setAttribute('aria-disabled', String(this.swiper.isBeginning));
    }
    if (this.nextBtn) {
      this.nextBtn.disabled = this.swiper.isEnd;
      this.nextBtn.setAttribute('aria-disabled', String(this.swiper.isEnd));
    }
  }
}

if (!customElements.get('testimonial-slider')) {
  customElements.define('testimonial-slider', TestimonialSlider);
}
